import React, { FC } from 'react';

import { useThemeMode } from '~/contexts/ThemeModeContext';

import chatwithaiBigLogoDarkTheme from '../../assets/chatwithai-big-logo-dark-theme.png';
import chatwithaiBigLogoLightTheme from '../../assets/chatwithai-big-logo-light-theme.png';
import polyIconLogoDarkTheme from '../../assets/poly-icon-logo-dark-theme.png';
import polyIconLogoLightTheme from '../../assets/poly-icon-logo-light-theme.png';

type LogoProps = {
  className?: string;
};

const ProjectLogo: FC<LogoProps> = ({ className }) => {
  const { themeMode } = useThemeMode();
  const logoSrc =
    themeMode === 'dark' ? polyIconLogoDarkTheme : polyIconLogoLightTheme;

  return <img src={logoSrc} alt="ChatWithAI logo" className={className} />;
};

const ProjectBigLogo: FC<LogoProps> = ({ className }) => {
  const { themeMode } = useThemeMode();
  const logoSrc =
    themeMode === 'dark'
      ? chatwithaiBigLogoDarkTheme
      : chatwithaiBigLogoLightTheme;

  return <img src={logoSrc} alt="ChatWithAI" className={className} />;
};

export { ProjectBigLogo, ProjectLogo };
